import { request } from '@faire/web-api--source';
import { IRecordRawAssignmentsRequest } from '@faire/web-api--source/faire/settings_boss/IRecordRawAssignmentsRequest';
import { RecordRawAssignmentsResponse } from '@faire/web-api--source/faire/settings_boss/RecordRawAssignmentsResponse';
import {
  EndpointOptions,
  RequestOptions,
  SuccessResponse,
} from '@faire/web-api--source/types';

export const path = () => {
  return `/api/v2/setting/record_raw_assignment`;
};

export const build = (
  data: IRecordRawAssignmentsRequest,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  const headers = options?.headers ?? new Headers();
  if (!headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  return {
    route,
    service,
    url: path(),
    method: 'POST',
    ignoreForRobots: true,
    data,
    ...options,
    headers,
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/v2/setting/record_raw_assignment';

/**
 * The service that handles this endpoint
 */
export const service = 'settings-boss';

/**
 *     Record assignment in the given setting's experiment, for the active user.
 *     This should be called by the client as close as possible to the moment that the UX branches between treatment and
 *     control.
 * Product Area: SETTINGS
 * Ignored (not called) during bot sessions.
 */
function execute(
  data: IRecordRawAssignmentsRequest
): Promise<RecordRawAssignmentsResponse>;
function execute(
  data: IRecordRawAssignmentsRequest,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<RecordRawAssignmentsResponse>>;
function execute(
  data: IRecordRawAssignmentsRequest,
  options?: EndpointOptions
): Promise<RecordRawAssignmentsResponse>;
function execute(
  data: IRecordRawAssignmentsRequest,
  options?: EndpointOptions
): Promise<
  RecordRawAssignmentsResponse | SuccessResponse<RecordRawAssignmentsResponse>
> {
  const requestOptions = build(data, options);
  return request<RecordRawAssignmentsResponse>(requestOptions);
}
export default execute;
